exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-top[data-v-ed7ebd44]{left:50%}", ""]);

// exports
